import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Scales a single line of display type so it runs the full width of its
 * container, whatever the font metrics. The element's first child is the
 * measured word; anything after it (screen-reader text) is ignored.
 */
const useFitText = <T extends HTMLElement>(max = 420) => {
  const ref = useRef<T>(null);
  const fit = useCallback(() => {
    const el = ref.current;
    const word = el?.firstElementChild as HTMLElement | null;
    if (!el || !word) return;
    el.style.fontSize = '100px';
    const w = word.getBoundingClientRect().width;
    if (w) el.style.fontSize = `${Math.min((el.clientWidth / w) * 100 * 0.995, max)}px`;
  }, [max]);
  useLayoutEffect(() => {
    fit();
    document.fonts?.ready.then(fit);
    const ro = new ResizeObserver(fit);
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, [fit]);
  return ref;
};

export default useFitText;
